import { SuperDialog } from "@components:SuperDialog";
import { SVGInternalIcon } from "@components:SVGInternalIcon";
import { Textarea } from "@components:Textarea";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import { SuperButton } from "@pages:app/docs/Components/SuperButton";
import { isEmpty } from "lodash";
import { ChangeEvent, useState } from "react";
import { useTranslation } from "react-i18next";

type WriteButtonProps = {
  content: string;
  onContentChange: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
};

export const WriteButton = ({ content, onContentChange }: WriteButtonProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box>
      <SuperButton
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "170px !important",
        }}
        onClick={() => setIsOpen(true)}
        isShownPingIcon={!isEmpty(content)}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          height="100%"
        >
          <Box display="flex" alignItems="center" gap={2}>
            <SVGInternalIcon icon="writeIcon" sx={{ width: 32, height: 32 }} />
            <Typography
              sx={{
                fontWeight: "500",
                fontSize: "20px",
                lineHeight: "26px",
              }}
            >
              {t("docs.write")}
            </Typography>
          </Box>
          <Typography
            sx={{
              textAlign: "left",
              fontWeight: "500",
              fontSize: "16px",
              lineHeight: "26px",
            }}
          >
            {t("docs.writeSubtitle")}
          </Typography>
        </Box>
      </SuperButton>
      <SuperDialog
        title={t("docs.textDialogTitle")}
        open={isOpen}
        onClose={() => setIsOpen(false)}
        sx={{
          "& .MuiDialog-paper": {
            width: "52rem",
            height: "29.7rem",
          },
          "& .MuiDialogActions-root": {
            marginTop: 0,
          },
        }}
        actionControls={{
          primary: {
            label: t("common.ok"),
            onClick: () => {
              setIsOpen(false);
            },
          },
          secondary: {
            label: t("common.clear"),
            onClick: () => {
              onContentChange({ target: { value: "" } } as any);
            },
          },
        }}
      >
        <Textarea
          value={content}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
            onContentChange(e);
          }}
          placeholder={t("docs.textPlaceholder")}
          sx={{
            flex: 1,
            minHeight: "17rem !important",
          }}
        />
      </SuperDialog>
    </Box>
  );
};
